import {NgModule} from '@angular/core';
import {ContractStructurePage} from "./page/overview/contract-structure/contract-structure.page";
import {InsurableObjectPage} from "./page/overview/insurable-object/insurable-object.page";
import {
    CmCustomerAssessmentComponent
} from "./component/protected-components/cm-customer-assessment/cm-customer-assessment.component";
import {
    CmInsuranceStackOverviewComponent
} from "./component/protected-components/cm-insurance-stack-overview/cm-insurance-stack-overview.component";
import {
    CmInsuranceOverallOverviewComponent
} from "./component/protected-components/cm-insurance-overall-overview/cm-insurance-overall-overview.component";
import {CmPartnerComponent} from "./component/protected-components/cm-partner/cm-partner.component";
import {
    CmSearchFlexibleContractComponent
} from "./search/cm-search-flexible-contract/cm-search-flexible-contract.component";
import {CmContractComponent} from "./component/protected-components/cm-contract/cm-contract.component";
import {DmModule} from "../../feature-core/dm/dm.module";
import {
    CmContractStatusTypeOverviewPage
} from "./page/overview/cm-contract-status-type-overview/cm-contract-status-type-overview.page";
import {
    CmContractStatusOverviewPage
} from "./page/overview/cm-contract-status-overview/cm-contract-status-overview.page";
import {CmContractPage} from "./page/overview/cm-contract-page/cm-contract.page";
import {ContractSearchPage} from "./page/overview/contract-search/contract-search.page";
import {ContractHistoryPage} from "./page/overview/cm-contract-history-page/contract-history.page";
import {
    CmCreateNewInsurableObjectComponent
} from "./component/protected-components/cm-create-new-insurable-object/cm-create-new-insurable-object.component";
import {
    CmCreateInsurableObjectOthersComponent
} from "./component/protected-components/cm-create-insurable-object-others/cm-create-insurable-object-others.component";
import {
    CmCreateInsurableObjectPersonComponent
} from "./component/protected-components/cm-create-insurable-object-person/cm-create-insurable-object-person.component";
import {
    CmCreateNewInsurableObjectObjectComponent
} from "./component/protected-components/cm-create-new-insurable-object/object/cm-create-related-person-object/cm-create-new-insurable-object-object.component";
import {
    CmContractStandardNavigationComponent
} from "./component/protected-components/cm-contract/components/cm-contract-standard-navigation/cm-contract-standard-navigation.component";
import {
    CmContractDocumentsNavigationComponent
} from "./component/protected-components/cm-contract/components/cm-contract-documents-navigation/cm-contract-documents-navigation.component";
import {
    CmContractDocumentUploadComponent
} from "./component/protected-components/cm-contract-document-upload/cm-contract-document-upload.component";
import {CmConfigPage} from "./page/overview/cm-config/cm-config.page";
import {PartnerConfigPage} from "./page/overview/partner-config/partner-config.page";
import {
    CmContractDashboardStatusPage
} from "./page/overview/cm-contract-dashboard-status/cm-contract-dashboard-status.page";
import {
    CmContractNotificationTypeObjectComponent
} from "./component/protected-components/cm-contract-notification-type-object/cm-contract-notification-type-object.component";
import {
    CmUpdateInsurableObjectComponent
} from "./component/protected-components/cm-update-insurable-object/cm-update-insurable-object.component";
import {
    CmUpdateInsurableObjectObjectComponent
} from "./component/protected-components/cm-update-insurable-object/object/cm-update-insurable-object-object/cm-update-insurable-object-object.component";
import {
    CmContractObjectsNavigationComponent
} from "./component/protected-components/cm-contract/components/cm-contract-objects-navigation/cm-contract-objects-navigation.component";
import {
    CmContractCoveragesNavigationComponent
} from "./component/protected-components/cm-contract/components/cm-contract-coverages-navigation/cm-contract-coverages-navigation.component";
import {
    CmContractExternalDataNavigationComponent
} from "./component/protected-components/cm-contract/components/cm-contract-external-data-navigation/cm-contract-external-data-navigation.component";
import {
    CmContractNavigationBaseComponentComponent
} from "./component/protected-components/cm-contract/components/cm-contract-navigation-base-component/cm-contract-navigation-base-component.component";
import {
    CmContractNavigationDropdownComponent
} from "./component/protected-components/cm-contract-navigation-dropdown/cm-contract-navigation-dropdown.component";
import {
    CmContractQuickActionsComponent
} from "./component/protected-components/cm-contract-quick-actions/cm-contract-quick-actions.component";
import {CmContractLastPage} from "./page/object/cm-contract-last/cm-contract-last.page";
import {NsModule} from "../../feature-core/ns/ns.module";
import {
    CmContractCombinedFormCreatePage
} from "./page/cm-contract-combined-form-create/cm-contract-combined-form-create.page";
import {
    CmCreateContractCombinedFormComponent
} from "./component/protected-components/cm-create-contract-combined-form/cm-create-contract-combined-form.component";
import {NgOptimizedImage} from "@angular/common";
import {AutoFocusModule} from "primeng/autofocus";
import {
    CmCreateInsurableObjectPersonRelationPersonComponent
} from "./component/protected-components/cm-create-insurable-object-person-relation-person/cm-create-insurable-object-person-relation-person.component";
import {TmModule} from "../../feature-core/tm/tm.module";
import {ContractOverviewPage} from "./page/contract-overview-page/contract-overview.page";
import {
    CmStatisticsComponent
} from "./page/contract-overview-page/components/statisticsComponent/cm-statistics.component";
import {CmKpiComponent} from "./page/contract-overview-page/components/kpiComponent/cm-kpi.component";
import {
    ContractBaseTypeComponent
} from "./component/protected-components/object-base-components/contract-base-type-component/contract-base-type.component";
import {CmPartnerSideComponent} from "./component/protected-components/cm-partner/view/side/cm-partner-side.component";
import {CmPartnerFullComponent} from "./component/protected-components/cm-partner/view/full/cm-partner-full.component";
import {CmPartnerBaseComponent} from "./component/protected-components/cm-partner/view/cm-partner-base.component";
import {
    ContractObjectFullComponent
} from "./component/protected-components/object-base-components/contract-component/view/full/contract-object-full.component";
import {
    ContractObjectSideComponent
} from "./component/protected-components/object-base-components/contract-component/view/side/contract-object-side.component";
import {
    ContractObjectComponent
} from "./component/protected-components/object-base-components/contract-component/contract-object.component";
import {
    ContractObjectBaseComponent
} from "./component/protected-components/object-base-components/contract-component/view/contract-object-base.component";
import {
    ContractObjectMiniSideComponent
} from "./component/protected-components/object-base-components/contract-component/view/mini-side/contract-object-mini-side.component";
import {
    CmSharedComponent
} from "./component/protected-components/object-base-components/contract-component/shared/cm-shared.component";
import {
    CmCommentComponent
} from "./component/protected-components/object-base-components/contract-component/shared/components/cm-comment/cm-comment.component";
import {
    CmFormerContractComponent
} from "./component/protected-components/object-base-components/contract-component/shared/components/cm-former-contract/cm-former-contract.component";
import {
    CmDocumentsComponent
} from "./component/protected-components/object-base-components/contract-component/shared/components/cm-documents/cm-documents.component";
import {
    CmContractServiceComponent
} from "./component/protected-components/object-base-components/contract-component/shared/components/cm-contract-service/cm-contract-service.component";
import {
    CmContractWidgetComponent
} from "./component/protected-components/object-base-components/contract-component/shared/components/cm-contract-widget/cm-contract-widget.component";
import {CM_ENTITY_PROVIDER} from "./cm.entity-provider";
import {
    CmContractInlineComponent
} from "./component/protected-components/cm-contract-inline-component/cm-contract-inline-component";
import {
    ContractObjectInlineComponent
} from "./component/protected-components/object-base-components/contract-component/view/inline/contract-object-inline.component";
import {CM_TEST_PROVIDERS} from "./test/cm-test-definition";
import {CoreModule} from "../../core/core.module";
import {DynamicModule} from "../../core/shared/interface/dynamic-module.interface";
import {ModuleRegistryService} from "../../core/shared/interface/module-registration.service";
import {
    ContractPersonObjectWidgetsComponent
} from "./component/protected-components/contract-person-object-widgets/contract-person-object-widgets.component";
import {CmContractConsultantPage} from "./page/consultant-page/overview/cm-contract-page/cm-contract-consultant.page";
import {
    CmContractConsultantComponent
} from "./component/protected-components/consultant-component/cm-contract/cm-contract-consultant.component";
import {
    CmContractStandardNavigationConsultantComponent
} from "./component/protected-components/consultant-component/cm-contract/components/cm-contract-standard-navigation/cm-contract-standard-navigation-consultant.component";
import {
    CmContractDocumentUploadConsultantComponent
} from "./component/protected-components/consultant-component/cm-contract-document-upload/cm-contract-document-upload-consultant.component";
import {
    CmContractObjectsNavigationConsultantComponent
} from "./component/protected-components/consultant-component/cm-contract/components/cm-contract-objects-navigation/cm-contract-objects-navigation-consultant.component";
import {
    ContractPersonObjectWidgetConsultantComponent
} from "./component/protected-components/consultant-component/contract-person-object-widgets/contract-person-object-widget-consultant.component";
import {
    CmContractTicketsComponent
} from "./component/protected-components/consultant-component/cm-contract-tickets/cm-contract-tickets.component";
import {
    CmPriceChangeWizardComponent
} from "./component/object-components/cm-price-change-wizard/cm-price-change-wizard.component";
import {
    CmPaymentPauseWizardComponent
} from "./component/object-components/cm-payment-pause-wizard/cm-payment-pause-wizard.component";
import {
    CmWizardStepPriceChangeBranchComponent
} from "./component/protected-components/cm-price-wizard/cm-wizard-step-price-change-branch/cm-wizard-step-price-change-branch.component";
import {
    CmWizardStepSuspensionEntryComponent
} from "./component/protected-components/cm-price-wizard/cm-wizard-step-suspension-entry/cm-wizard-step-suspension-entry.component";
import {
    CmWizardStepSuspensionSummaryComponent
} from "./component/protected-components/cm-price-wizard/cm-wizard-step-suspension-summary/cm-wizard-step-suspension-summary.component";
import {
    CmWizardStepSummaryComponent
} from "./component/protected-components/cm-price-wizard/cm-wizard-step-summary/cm-wizard-step-summary.component";
import {
    CmWizardStepPriceContextComponent
} from "./component/protected-components/cm-price-wizard/cm-wizard-step-price-context/cm-wizard-step-price-context.component";
import {
    CmWizardStepPriceEntryComponent
} from "./component/protected-components/cm-price-wizard/cm-wizard-step-price-entry/cm-wizard-step-price-entry.component";
import {
    CmPaymentSuspensionReportingDialogComponent
} from "./component/protected-components/cm-payment-suspension-reporting-dialog/cm-payment-suspension-reporting-dialog.component";
import {
    CmContractTerminationWizardComponent
} from "./component/protected-components/cm-contract-termination-wizard/cm-contract-termination-wizard.component";
import {
    CmCtwStepModeComponent
} from "./component/protected-components/cm-contract-termination-wizard/cm-ctw-step-mode/cm-ctw-step-mode.component";
import {
    CmWizardStepDocumentComponent
} from "./component/protected-components/cm-wizard-step-document/cm-wizard-step-document.component";
import {
    CmWizardStepTerminationRevocationComponent
} from "./component/protected-components/cm-wizard-step-termination-revocation/cm-wizard-step-termination-revocation.component";
import {
    CmContractWithdrawalWizardComponent
} from "./component/protected-components/cm-contract-withdrawal-wizard/cm-contract-withdrawal-wizard.component";
import {
    CmContractStructureComponent
} from "./component/protected-components/cm-contract-structure/cm-contract-structure.component";
import {
    CmContractTypeAmountTreeComponent
} from "./component/protected-components/cm-contract-type-amount-tree/cm-contract-type-amount-tree.component";
import {
    CmContractTypeObjectComponent
} from "./component/object-components/cm-contract-type-object-component/cm-contract-type-object.component";
import {
    CmProductObjectComponent
} from "./component/object-components/cm-product-object-component/cm-product-object.component";
import {
    CmGeneralAgencyObjectComponent
} from "./component/object-components/cm-general-agency-object-component/cm-general-agency-object.component";
import {CmProductObjectPage} from "./page/object/cm-product-object-page/cm-product-object.page";
import {
    CmContractSearchTestPage
} from "./page/overview/cm-contract-search-test/cm-contract-search-test.page";
import {
    CmContractSearchComponent
} from "./component/protected-components/cm-contract-search/cm-contract-search.component";
import {
    CmContractSearchTabsComponent
} from "./component/protected-components/cm-contract-search/components/cm-contract-search-tabs/cm-contract-search-tabs.component";
import {
    CmContractSearchPanelComponent
} from "./component/protected-components/cm-contract-search/components/cm-contract-search-panel/cm-contract-search-panel.component";
import {
    CmContractSearchCustomerInputComponent
} from "./component/protected-components/cm-contract-search/components/cm-contract-search-customer-input/cm-contract-search-customer-input.component";
import {
    CmContractResultListComponent
} from "./component/protected-components/cm-contract-search/components/cm-contract-result-list/cm-contract-result-list.component";
import {
    CmEdKvListComponent
} from "./component/protected-components/cm-contract/components/cm-contract-external-data-navigation/components/cm-ed-kv-list/cm-ed-kv-list.component";
import {
    CmEdCoverageCardComponent
} from "./component/protected-components/cm-contract/components/cm-contract-external-data-navigation/components/cm-ed-coverage-card/cm-ed-coverage-card.component";
import {
    CmEdPersonCardComponent
} from "./component/protected-components/cm-contract/components/cm-contract-external-data-navigation/components/cm-ed-person-card/cm-ed-person-card.component";
import {
    CmEdObjectCardComponent
} from "./component/protected-components/cm-contract/components/cm-contract-external-data-navigation/components/cm-ed-object-card/cm-ed-object-card.component";
import {
    CmEdStrukturStripComponent
} from "./component/protected-components/cm-contract/components/cm-contract-external-data-navigation/components/cm-ed-struktur-strip/cm-ed-struktur-strip.component";
import {
    CmEdBasisBandComponent
} from "./component/protected-components/cm-contract/components/cm-contract-external-data-navigation/components/cm-ed-basis-band/cm-ed-basis-band.component";
import {
    CmEdBlockErrorComponent
} from "./component/protected-components/cm-contract/components/cm-contract-external-data-navigation/components/cm-ed-block-error/cm-ed-block-error.component";
import {
    CmEdBlockSectionComponent
} from "./component/protected-components/cm-contract/components/cm-contract-external-data-navigation/components/cm-ed-block-section/cm-ed-block-section.component";
import {
    CmEdVerdictBannerComponent
} from "./component/protected-components/cm-contract/components/cm-contract-external-data-navigation/components/cm-ed-verdict-banner/cm-ed-verdict-banner.component";
import {
    CmEdViewPersonMatrixComponent
} from "./component/protected-components/cm-contract/components/cm-contract-external-data-navigation/views/cm-ed-view-person-matrix/cm-ed-view-person-matrix.component";
import {
    CmEdViewModuleMatrixComponent
} from "./component/protected-components/cm-contract/components/cm-contract-external-data-navigation/views/cm-ed-view-module-matrix/cm-ed-view-module-matrix.component";
import {
    CmEdViewCompactComponent
} from "./component/protected-components/cm-contract/components/cm-contract-external-data-navigation/views/cm-ed-view-compact/cm-ed-view-compact.component";
// TM-1000002050: the „VN-Wechsel“ wizard — host (exported for the ci slot host) and its seven steps
import {
    CmPolicyholderChangeWizardComponent
} from "./component/object-components/cm-policyholder-change-wizard/cm-policyholder-change-wizard.component";
import {
    CmPhcStepDateComponent
} from "./component/protected-components/cm-policyholder-change-wizard/cm-phc-step-date/cm-phc-step-date.component";
import {
    CmPhcStepModeComponent
} from "./component/protected-components/cm-policyholder-change-wizard/cm-phc-step-mode/cm-phc-step-mode.component";
import {
    CmPhcStepTargetComponent
} from "./component/protected-components/cm-policyholder-change-wizard/cm-phc-step-target/cm-phc-step-target.component";
import {
    CmPhcStepBillingAccountComponent
} from "./component/protected-components/cm-policyholder-change-wizard/cm-phc-step-billing-account/cm-phc-step-billing-account.component";
import {
    CmPhcStepTermComponent
} from "./component/protected-components/cm-policyholder-change-wizard/cm-phc-step-term/cm-phc-step-term.component";
import {
    CmPhcStepSimulationComponent
} from "./component/protected-components/cm-policyholder-change-wizard/cm-phc-step-simulation/cm-phc-step-simulation.component";
import {
    CmPhcStepSummaryComponent
} from "./component/protected-components/cm-policyholder-change-wizard/cm-phc-step-summary/cm-phc-step-summary.component";

@NgModule({
    declarations: [
        ContractStructurePage,
        InsurableObjectPage,
        CmCustomerAssessmentComponent,
        CmInsuranceStackOverviewComponent,
        CmInsuranceOverallOverviewComponent,
        CmPartnerComponent,
        CmSearchFlexibleContractComponent,
        CmContractComponent,
        CmContractStatusTypeOverviewPage,
        CmContractStatusOverviewPage,
        CmContractPage,
        ContractSearchPage,
        ContractHistoryPage,
        CmCreateNewInsurableObjectComponent,
        CmCreateInsurableObjectOthersComponent,
        CmCreateInsurableObjectPersonComponent,
        CmCreateNewInsurableObjectObjectComponent,
        CmContractStandardNavigationComponent,
        CmContractDocumentsNavigationComponent,
        CmContractDocumentUploadComponent,
        CmConfigPage,
        CmContractDashboardStatusPage,
        CmContractNotificationTypeObjectComponent,
        CmUpdateInsurableObjectComponent,
        CmUpdateInsurableObjectObjectComponent,
        CmContractObjectsNavigationComponent,
        CmContractCoveragesNavigationComponent,
        CmContractExternalDataNavigationComponent,
    //     External contract data (Datenblatt): the shared building blocks, then the three SHAPE VIEWS
    //     the host dispatches onto per Sparte. The four candidate layouts that used to be listed here
    //     were removed with the view menu — the layout is no longer chosen by a reader, it is chosen
    //     by the server's classification of each delivered Sparte.
        CmEdKvListComponent,
        CmEdCoverageCardComponent,
        CmEdPersonCardComponent,
        CmEdObjectCardComponent,
        CmEdStrukturStripComponent,
        CmEdBasisBandComponent,
        CmEdBlockErrorComponent,
        CmEdBlockSectionComponent,
        CmEdVerdictBannerComponent,
        CmEdViewPersonMatrixComponent,
        CmEdViewModuleMatrixComponent,
        CmEdViewCompactComponent,
        CmContractNavigationBaseComponentComponent,
        CmContractNavigationDropdownComponent,
    //     TM-1000001998: the contract header's "Quick Actions" container — menu model plus the four
    //     wizard dialogs, which had to leave cm-contract-standard-navigation because that component
    //     is destroyed on every non-standard tab while the header survives.
        CmContractQuickActionsComponent,
        CmContractLastPage,
        CmContractCombinedFormCreatePage,
        CmCreateContractCombinedFormComponent,
        CmCreateInsurableObjectPersonRelationPersonComponent,
        ContractOverviewPage,
        CmStatisticsComponent,
        CmKpiComponent,
        ContractBaseTypeComponent,
        CmPartnerSideComponent,
        CmPartnerFullComponent,
        CmPartnerBaseComponent,
        ContractObjectFullComponent,
        ContractObjectSideComponent,
        ContractObjectComponent,
        ContractObjectBaseComponent,
        ContractObjectMiniSideComponent,
        CmSharedComponent,
        CmCommentComponent,
        CmFormerContractComponent,
        CmDocumentsComponent,
        CmContractServiceComponent,
        CmContractWidgetComponent,
        CmContractInlineComponent,
        ContractObjectInlineComponent,
        ContractPersonObjectWidgetsComponent,

    //     Price Wizards (Preisänderung / Beitrag aussetzen)
        CmPriceChangeWizardComponent,
        CmPaymentPauseWizardComponent,
        CmWizardStepPriceChangeBranchComponent,
        CmWizardStepPriceContextComponent,
        CmWizardStepPriceEntryComponent,
        CmWizardStepSummaryComponent,
        CmWizardStepSuspensionEntryComponent,
        CmWizardStepSuspensionSummaryComponent,

    //     Beitragsaussetzung — row action „An Versicherer gemeldet …“ of the suspension widget
        CmPaymentSuspensionReportingDialogComponent,

    //     Termination (Kündigung) Wizard
        CmContractTerminationWizardComponent,
        CmCtwStepModeComponent,

    //     Withdrawal (Widerruf) Wizard
        CmContractWithdrawalWizardComponent,

    //     Shared Wizard Steps
        CmWizardStepDocumentComponent,
        CmWizardStepTerminationRevocationComponent,

    //     TM-1000002050: VN-Wechsel (Versicherungsnehmerwechsel) Wizard — host + seven steps
        CmPolicyholderChangeWizardComponent,
        CmPhcStepDateComponent,
        CmPhcStepModeComponent,
        CmPhcStepTargetComponent,
        CmPhcStepBillingAccountComponent,
        CmPhcStepTermComponent,
        CmPhcStepSimulationComponent,
        CmPhcStepSummaryComponent,

    //     Consultant
        CmContractConsultantPage,
        CmContractConsultantComponent,
        CmContractStandardNavigationConsultantComponent,
        CmContractDocumentUploadConsultantComponent,
        CmContractObjectsNavigationConsultantComponent,
        ContractPersonObjectWidgetConsultantComponent,
        CmContractTicketsComponent,

    //     Contract Structure & Object Components
        CmContractStructureComponent,
        CmContractTypeAmountTreeComponent,
        CmContractTypeObjectComponent,
        CmProductObjectComponent,
        CmGeneralAgencyObjectComponent,

    //     Product Object Page
        CmProductObjectPage,

    //     Contract Search (tailor-made)
        CmContractSearchComponent,
        CmContractSearchTabsComponent,
        CmContractSearchPanelComponent,
        CmContractSearchCustomerInputComponent,
        CmContractResultListComponent,
        CmContractSearchTestPage,
        PartnerConfigPage,
    ],
    exports: [
        ContractStructurePage,
        InsurableObjectPage,
        CmCustomerAssessmentComponent,
        CmInsuranceStackOverviewComponent,
        CmInsuranceOverallOverviewComponent,
        CmPartnerComponent,
        CmSearchFlexibleContractComponent,
        CmContractComponent,
        CmContractStatusTypeOverviewPage,
        CmContractStatusOverviewPage,
        CmContractPage,
        ContractSearchPage,
        ContractHistoryPage,
        CmCreateNewInsurableObjectComponent,
        CmCreateInsurableObjectOthersComponent,
        CmCreateInsurableObjectPersonComponent,
        CmCreateNewInsurableObjectObjectComponent,
        CmContractStandardNavigationComponent,
        CmContractDocumentsNavigationComponent,
        CmContractDocumentUploadComponent,
        CmConfigPage,
        CmContractDashboardStatusPage,
        CmContractNotificationTypeObjectComponent,
        CmUpdateInsurableObjectComponent,
        CmUpdateInsurableObjectObjectComponent,
        CmContractObjectsNavigationComponent,
        CmContractCoveragesNavigationComponent,
        CmContractExternalDataNavigationComponent,
    //     External contract data (Datenblatt): the shared building blocks, then the three SHAPE VIEWS
    //     the host dispatches onto per Sparte. The four candidate layouts that used to be listed here
    //     were removed with the view menu — the layout is no longer chosen by a reader, it is chosen
    //     by the server's classification of each delivered Sparte.
        CmEdKvListComponent,
        CmEdCoverageCardComponent,
        CmEdPersonCardComponent,
        CmEdObjectCardComponent,
        CmEdStrukturStripComponent,
        CmEdBasisBandComponent,
        CmEdBlockErrorComponent,
        CmEdBlockSectionComponent,
        CmEdVerdictBannerComponent,
        CmEdViewPersonMatrixComponent,
        CmEdViewModuleMatrixComponent,
        CmEdViewCompactComponent,
        CmContractNavigationBaseComponentComponent,
        CmContractNavigationDropdownComponent,
        CmContractLastPage,
        CmContractCombinedFormCreatePage,
        CmCreateContractCombinedFormComponent,
        CmCreateInsurableObjectPersonRelationPersonComponent,
        ContractBaseTypeComponent,
        ContractObjectFullComponent,
        ContractObjectSideComponent,
        ContractObjectComponent,
        ContractObjectBaseComponent,
        ContractObjectMiniSideComponent,
        CmSharedComponent,
        CmCommentComponent,
        CmFormerContractComponent,
        CmDocumentsComponent,
        CmContractServiceComponent,
        CmContractWidgetComponent,
        ContractPersonObjectWidgetsComponent,

    //     Price Wizards (Preisänderung / Beitrag aussetzen)
        CmPriceChangeWizardComponent,
        CmPaymentPauseWizardComponent,
        CmWizardStepPriceContextComponent,
        CmWizardStepPriceEntryComponent,
        CmWizardStepSummaryComponent,

    //     Termination (Kündigung) Wizard
        CmContractTerminationWizardComponent,

    //     Withdrawal (Widerruf) Wizard
        CmContractWithdrawalWizardComponent,

    //     Shared Wizard Steps
        CmWizardStepDocumentComponent,
        CmWizardStepTerminationRevocationComponent,

    //     TM-1000002050: VN-Wechsel Wizard — only the host; the ci slot host renders it (the steps stay internal)
        CmPolicyholderChangeWizardComponent,

    //     Consultant
        CmContractConsultantPage,
        CmContractConsultantComponent,
        CmContractStandardNavigationConsultantComponent,
        CmContractDocumentUploadConsultantComponent,
        CmContractObjectsNavigationConsultantComponent,
        ContractPersonObjectWidgetConsultantComponent,
        CmContractNavigationBaseComponentComponent,
        CmContractTicketsComponent,

    //     Contract Structure & Object Components
        CmContractStructureComponent,
        CmContractTypeAmountTreeComponent,
        CmContractTypeObjectComponent,
        CmProductObjectComponent,
        CmGeneralAgencyObjectComponent,

    //     Product Object Page
        CmProductObjectPage,

    //     Contract Search (tailor-made)
        CmContractSearchComponent,
        CmContractSearchTabsComponent,
        CmContractSearchPanelComponent,
        CmContractSearchCustomerInputComponent,
        CmContractResultListComponent,
        CmContractSearchTestPage,
        ],
    imports: [
        CoreModule,
        DmModule,
        NsModule,
        NgOptimizedImage,
        TmModule,
        // `pAutoFocus` on the external-data sheet's search box — the box and the icon that opens it
        // are two arms of one `@if`, and the directive is what carries keyboard focus across the
        // swap without a view query.
        AutoFocusModule,
        // cm-wizard-message-area (the two price wizards, Stornieren) is declared and exported by
        // SharedModule, which CoreModule above re-exports — nothing to import here.
    ],
    providers: [CM_ENTITY_PROVIDER, CM_TEST_PROVIDERS]
})
export class CmModule implements DynamicModule {

    alias = 'cm';

    constructor(private moduleRegistry: ModuleRegistryService) {
        this.moduleRegistry.registerModule(this);
    }

    getKpiComponent() {
        return CmKpiComponent;
    }

    getStatisticsComponent() {
        return CmStatisticsComponent;
    }
}
